module.exports = __webpack_public_path__ + "img/coach-slide4.c76391b6.png";